goog.provide("shadow.js.shim.module$src$svg$inform$min_svg");
goog.provide("module$shadow_js_shim_module$src$svg$inform$min_svg");
shadow.js.shim.module$src$svg$inform$min_svg = shadow.js.nativeProvides["src/svg/inform/min.svg"] = shadow$bridge("src/svg/inform/min.svg");
module$shadow_js_shim_module$src$svg$inform$min_svg.default = shadow.js.shim.module$src$svg$inform$min_svg;
